import { render, staticRenderFns } from "./GrmAlert.vue?vue&type=template&id=352d0931&scoped=true&"
import script from "./GrmAlert.vue?vue&type=script&lang=js&"
export * from "./GrmAlert.vue?vue&type=script&lang=js&"
import style0 from "./GrmAlert.vue?vue&type=style&index=0&id=352d0931&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d0931",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352d0931')) {
      api.createRecord('352d0931', component.options)
    } else {
      api.reload('352d0931', component.options)
    }
    module.hot.accept("./GrmAlert.vue?vue&type=template&id=352d0931&scoped=true&", function () {
      api.rerender('352d0931', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/alert/GrmAlert.vue"
export default component.exports